import simpleSlider from 'simple-jQuery-slider'

var mainslider;

if (jQuery(".slider").length > 0) {
    jQuery(document).ready(function(){
        let options = {
            slides: '.slide', // The name of a slide in the slidesContainer
            swipe: false,    // Add possibility to Swipe > note that you have to include touchSwipe for this
            transition: "fade", // Accepts "slide" and "fade" for a slide or fade transition
            slideTracker: true, // Add a UL with list items to track the current slide
            slideTrackerID: 'slideposition', // The name of the UL that tracks the slides
            slideOnInterval: true, // Slide on interval
            interval: 6500, // Interval to slide on if slideOnInterval is enabled
            animateDuration: 500, // Duration of an animation
            animationEasing: 'easeInCirc', // Accepts: linear ease in out in-out snap easeOutCubic easeInOutCubic easeInCirc easeOutCirc easeInOutCirc easeInExpo easeOutExpo easeInOutExpo easeInQuad easeOutQuad easeInOutQuad easeInQuart easeOutQuart easeInOutQuart easeInQuint easeOutQuint easeInOutQuint easeInSine easeOutSine easeInOutSine easeInBack easeOutBack easeInOutBack
            pauseOnHover: false, // Pause when user hovers the slide container
            magneticSwipe: false, // This will attach the slides to the mouse's position when swiping/dragging
            neverEnding: true // Enable this to create a 'neverending' effect.
        };

        jQuery(".slider").simpleSlider(options);
        mainslider = jQuery(".slider").data("simpleslider");

        jQuery('.slide .backstretch img').on('dragstart', function(event) { event.preventDefault(); });

        jQuery('.slider-container .prev').click(function(){
            mainslider.prevSlide();
            return false;
        });

        jQuery('.slider-container .next').click(function(){
            mainslider.nextSlide();
            return false;
        });

        jQuery('.go-low').click(function() {
            jQuery('html, body').animate({
                scrollTop: jQuery('.content').offset().top
            }, 'slow');
            return false;
        });
    });
}

if (jQuery(".slider .bottom").length > 0 || jQuery(".jumbotron .bottom").length > 0) {

    // fadeout effect variables

    let fadeStart = 400;
    let fadeUntil = 800;
    let fading = jQuery('.slider .bottom, .jumbotron .bottom');

    jQuery(window).on('scroll', function(){
        let opacity = 0;
        let offset = jQuery(window).scrollTop();

        if ( offset <= fadeStart ){
            opacity= 1;
        } else if ( offset <= fadeUntil ){
            opacity = 1 - offset/fadeUntil;
        }

        fading.css('opacity', opacity);
    });
}

if (jQuery("body").hasClass('home')) {


}


// WEBPACK FOOTER //
// ./resources/assets/js/partial/slider.js